import { Paper, Typography, Box, Button } from '@mui/material';
import { useAppSelector } from 'shared/lib/hooks/hooks';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppDispatch } from 'shared/config/configureStore';
import { getMarathonsDistancesPrice } from 'api/thunk/marathons/getActions/getMarathonsDistancesPrice';
import { useTranslation } from 'react-i18next';

interface IMobileSummery {
  step: 1 | 2 | 3;
  setStep: Dispatch<SetStateAction<1 | 2 | 3>>;
  changeDistance: boolean;
  setChangeDistance: (value: boolean) => void;
  handleOpenChangeDistanceModal: () => void;
}

const MobileSummery = ({ step, setStep, changeDistance, setChangeDistance, handleOpenChangeDistanceModal }: IMobileSummery) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const products = useAppSelector((state) => state.products.productsById.params.products);
  const totalPrice = products?.reduce((sum, product) => sum + product.price * product.quantity, 0);
  const { marathon, isInsuranceNeeded, distanceId, distancePrice } = useAppSelector(
    (state) => ({
      marathon: state.marathons.marathonsById.response.data,
      isInsuranceNeeded: state.marathons.marathonsById.params.insurance,
      distanceId: state.marathons.marathonsById.params.distance,
      distancePrice: state.marathons.marathonsDistancesPrice.response.data,
    })
  );
  const promocodes = useAppSelector((state) => state.promocodes.promocodesValidate.data);

  const promocodeId =
    promocodes && typeof promocodes === "object"
      ? promocodes.id
      : undefined;

  useEffect(() => {
    if (distanceId === null) return;
    if (!marathon?.id) return;

    dispatch(getMarathonsDistancesPrice({
      marathonId: Number(marathon.id),
      distanceId: Number(distanceId),
      promocodeId: promocodeId,
      includeInsurance: isInsuranceNeeded,
    }));
  }, [distanceId, isInsuranceNeeded, marathon, dispatch, promocodeId]);

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        borderRadius: 0,
        padding: "16px",
        boxShadow: "0px -4px 12px rgba(0,0,0,0.1)",
        zIndex: 999,
        backgroundColor: "#fff",
      }}
    >
      <Typography sx={{ fontSize: "18px", marginBottom: "16px", textAlign: 'start' }}>
        {((distancePrice || 0) + (totalPrice || 0))} {t("myMarathon.som")}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
        {step > 1 && (
          <Button
            variant="outlined"
            onClick={() => setStep((step - 1) as 1 | 2 | 3)}
            sx={{ flex: 1, borderRadius: '12px' }}
          >
            {t("createMarathon.back")}
          </Button>
        )}
        {step < 3 && (
          <Button
            variant="contained"
            onClick={() => setStep((step + 1) as 1 | 2 | 3)}
            sx={{ flex: 1, borderRadius: '12px', backgroundColor: "#0090D1" }}
          >
            {t("createMarathon.next")}
          </Button>
        )}
        {step === 3 && (
          <Button
            variant="contained"
            onClick={() => handleOpenChangeDistanceModal()}
            sx={{ flex: 1, whiteSpace: 'nowrap', borderRadius: '12px', backgroundColor: "#0090D1" }}
          >
            {t("buttons.proceedToPayment")}
          </Button>
        )}
      </Box>
    </Paper >
  );
};

export default MobileSummery;
